import { promiseFetchDataAuth } from 'crk-front-lib';
import { isValidMailAddress } from 'crk-front-lib/tools/mail-util';

const APIPATH = '/api/v2';

export function updatePassword(data, callback) {
  // console.info(data);
  if (data.oldpwd === '' || data.newpwd === '' || data.repwd === '') {
    callback('กรุณาป้อนข้อมูลให้ครบทุกช่อง');
    return;
  }

  if (data.newpwd.length < 6) {
    callback('รหัสผ่านสั้นเกินไป');
    return;
  }

  if (data.newpwd !== data.repwd) {
    callback('รหัสผ่านไม่ตรงกันในทั้งสองช่อง');
    return;
  }

  const url = `${APIPATH}/member/change-password`;
  promiseFetchDataAuth(url, 'POST', data)
  .then(res => {
    // console.info(res)
    callback(null, res);
  })
  .catch(err => {
    callback(err);
  });
}

export function requestPassword(data, callback) {
  if (!isValidMailAddress(data.email)) {
    callback('Email ไม่ถูกต้อง');
    return;
  }

  const url = `${APIPATH}/generate-password`;
  promiseFetchDataAuth(url, 'POST', data)
  .then(res => {
    console.info(res)
    callback(null, res);
  })
  .catch(err => {
    callback(err);
  });
}

export function submitPassword(data, callback) {
  if (!isValidMailAddress(data.email)) {
    callback('Email ไม่ถูกต้อง');
    return;
  }

  if (data.oldpwd === '' || data.newpwd === '' || data.repwd === '') {
    callback('กรุณาป้อนข้อมูลให้ครบทุกช่อง');
    return;
  }

  if (data.newpwd.length < 6) {
    callback('รหัสผ่านสั้นเกินไป');
    return;
  }

  if (data.newpwd !== data.repwd) {
    callback('รหัสผ่านไม่ตรงกันในทั้งสองช่อง');
    return;
  }

  const url = `${APIPATH}/submit-password`;
  promiseFetchDataAuth(url, 'POST', data)
  .then(res => {
    // console.info(res)
    callback(null, res);
  })
  .catch(err => {
    callback(err);
  });
}